import $ from 'jquery'

const loading = () => {
	const $loading = $('.j-loading')
	const $loadingText = $('.j-loading-text')
	const $fullpage = $('.j-fullpage')
	let num = 0
	let timer = null
	$(function () {
		let percent = ''
		timer = setInterval(() => {
			num < 99 && num++
			percent = num + '%'
			$loadingText.text(percent)
		}, 120)
	})
	window.addEventListener('load', () => {
		$fullpage.addClass('show')
		clearInterval(timer)
		$loadingText.text('100%')
		$loading.fadeOut()
	})
}

export default loading
